import React from 'react'
import styled, { css } from 'styled-components'
import { space, background, textAlign } from 'styled-system'
import { H3, H6 } from 'components/atoms/Typography'
import Container from 'components/atoms/Container'
import { Box, Grid } from 'components/atoms/Layout'
import { theme, mq } from 'config/theme'
import plus from 'assets/svg/plus.svg'
import minus from 'assets/svg/minus.svg'

const ICON_OFFSET = theme.space.l

const iconStyle = ({ icon }) => css`
  content: '';
  display: block;
  position: absolute;
  transform: translateY(8%);
  width: 1.2em;
  height: 1.2em;
  line-height: 1;
  background: url("${icon}") center / 90% no-repeat;
  ${background}
`

const ListItem = styled.li`
  position: relative;
  ${({ isIconOnRightSide }) =>
    isIconOnRightSide
      ? css`
          text-align: left;
          ${mq.from.tablet`
            text-align: right;
          `}
          ::after {
            ${iconStyle}
            top: 0;
            left: -${ICON_OFFSET};
            ${mq.from.tablet`
              left: auto;
              right: -${ICON_OFFSET};
            `}
          }
        `
      : css`
          ::before {
            ${iconStyle}
            top: 0;
            left: ${`-${ICON_OFFSET}`};
          }
        `}
  ${({ isStrikeThrough }) =>
    isStrikeThrough && `text-decoration: line-through;`}
  ${textAlign}
`

const UnorderedList = styled.ul`
  padding: 0;
  margin: 0;
  list-style: none;
  ${space}
  > ul,
  > li + li {
    margin-top: ${theme.space.m};
  }
`

const Comparison = () => {
  return (
    <Container>
      <H3 textAlign="center">Own vs rent</H3>
      <Grid
        gridGap="l"
        justifyContent="center"
        gridTemplateColumns={{ mobile: '1fr', tablet: '1fr 1fr' }}
      >
        <Box px={ICON_OFFSET}>
          <UnorderedList>
            <ListItem textAlign={{ mobile: 'left', tablet: 'right' }}>
              <H6 display="inline-block" m="0">
                Own
              </H6>
            </ListItem>
            <UnorderedList>
              <ListItem icon={plus} isIconOnRightSide>
                Opportunity to build equity
              </ListItem>
              <ListItem icon={plus} isIconOnRightSide>
                Benefits of tax savings*
              </ListItem>
              <ListItem icon={plus} isIconOnRightSide>
                Ability to make improvements
              </ListItem>
              <ListItem icon={plus} isIconOnRightSide>
                Pride of ownership
              </ListItem>
              <ListItem icon={plus} isIconOnRightSide>
                Be your own Landlord
              </ListItem>
            </UnorderedList>
          </UnorderedList>
        </Box>
        <Box px={ICON_OFFSET}>
          <UnorderedList>
            <li>
              <H6 display="inline-block" m="0">
                Rent
              </H6>
            </li>
            <UnorderedList>
              <ListItem icon={minus} isStrikeThrough>
                Annual rental increases
              </ListItem>
              <ListItem icon={minus} isStrikeThrough>
                Throwing money away
              </ListItem>
              <ListItem icon={minus} isStrikeThrough>
                No living stability
              </ListItem>
              <ListItem icon={minus} isStrikeThrough>
                Management issues and limitations
              </ListItem>
              <ListItem icon={minus} isStrikeThrough>
                No control over your premises
              </ListItem>
            </UnorderedList>
          </UnorderedList>
        </Box>
      </Grid>
    </Container>
  )
}

export default Comparison
